import { render, staticRenderFns } from "./team-details.vue?vue&type=template&id=14bfde7c&scoped=true"
import script from "./team-details.vue?vue&type=script&lang=js"
export * from "./team-details.vue?vue&type=script&lang=js"
import style0 from "./team-details.vue?vue&type=style&index=0&id=14bfde7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bfde7c",
  null
  
)

export default component.exports